module.exports = __webpack_public_path__ + "img/our-marketing-bg.e3b27138.png";